const state = () => ({
  categoryData: {
    facets: {},
    suggestions: {},
    page: 1,
    perPage: 10,
    totalCount: 0,
    data: {},
    html: {
      title: '',
      description: '',
      url: '',
    },
  },
  backgroundImageUrl: '',
  latest: [],
  latestLoading: false,
  popular: [],
  searchedElements: [],
});

const getters = {
  categoryData: ({ categoryData }) => categoryData,
  title: ({ categoryData }) => _.get(categoryData, 'html.title', categoryData.name),
  description: ({ categoryData }) => _.get(categoryData, 'html.description', ''),
  url: ({ categoryData }) => _.get(categoryData, 'html.url'),
  backgroundImageUrl: ({ backgroundImageUrl }) => backgroundImageUrl,
  latest: ({ latest }) => latest,
  latestLoading: ({ latestLoading }) => latestLoading,
  popular: ({ popular }) => popular,
  searchedElements: ({ searchedElements }) => searchedElements,
};

const mutations = {
  setCategoryData(state, data) {
    state.categoryData = data;
  },
  setLatest(state, data) {
    state.latest = data;
  },
  setLatestLoading(state, value) {
    state.latestLoading = value;
  },
  setPopular(state, data) {
    state.popular = data;
  },
  setBackgroundImageUrl(state, url) {
    state.backgroundImageUrl = url;
  },
  setSearchedElements(state, data) {
    state.searchedElements = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
